module.exports = __webpack_public_path__ + "4594bfee703fd900be34e68193e403c2.svg";